import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import styled, { css } from 'styled-components';
import { alignItemsFlexStart } from 'shared/styles/commonStyles';

import FaultsReportHoverBox from 'features/faults/components/FaultsReportHoverBox';
import ButtonGroup from './ButtonGroup';
import SwitchNavGroup from './SwitchNavGroup';
import {
  selectUserInfo,
} from 'shared/slice/userSlice';
import { createBrowserHistory } from 'history';
import { selectFaults } from 'shared/slice/FaultsSlice';
import { GeneralContext } from 'shared/context/contextOfGeneral';

const Sidebar = () => {

  const userInfo = useSelector(selectUserInfo);
  const {
    isEssSwitch,
    isTesSwitch,
    isTgsSwitch,
  } = userInfo;
  const faultsState = useSelector(selectFaults);
  const essFaultMessages = faultsState.messages.ess;
  const tgsFaultMessages = faultsState.messages.tgs;
  const tesFaultMessages = faultsState.messages.tes;
  const essFaultsNumber = isEssSwitch ? essFaultMessages.length : 0;
  const tgsFaultsNumber = isTesSwitch ? tgsFaultMessages.length : 0;
  const tesFaultsNumber = isTgsSwitch ? tesFaultMessages.length : 0;
  const isFault = essFaultsNumber + tgsFaultsNumber + tesFaultsNumber > 0;


  const { src1, src2, src4, handleOnClick } = useContext(GeneralContext);


  const [openFaultsReport, setOpenFaultsReport] = useState(false);

  const link1 = ['/', '/telemetry'];
  const link2 = ['/ess', '/tgs', '/tes'];
  const link4 = ['/settings', '/auditTrail', '/faults', '/reportStatus'];

  const history = createBrowserHistory();

  const { pathname } = history.location;

  useEffect(() => {
    const locationA = link1.some((el) => pathname === el);
    const locationB = link2.some((el) => pathname === el);

    if (locationA) {
      const id = pathname === '/' ? 0 : 1;
      handleOnClick('groupA', id);
    } else if (locationB) {
      const id = pathname === '/ess' ? 0 : pathname === '/tgs' ? 1 : 2;
      handleOnClick('groupB', id);
    } else {
      handleOnClick('groupD'.id);
    }

    const path = `${pathname}${history.location.hash || ''}`;
    history.push(`?path=${path}`);
  }, [pathname, isFault]);

  const groups = [
    {
      name: 'groupA',
      src: src1,
      link: link1,
      disabled: [false, false],
    },
    {
      name: 'groupB',
      src: src2,
      link: link2,
      disabled: [!isEssSwitch, !isTgsSwitch, !isTesSwitch],
    },
    {
      name: 'groupD',
      src: src4,
      link: link4,
      disabled: [false, false, false, false],
      isFault,
      setOpenFaultsReport,
    },
  ];

  return (
    <StylingWrapper>
      <Wrapper positionRelative={openFaultsReport}>
        {groups.map((group, index) =>
          group.name === 'groupB' ? (
            <SwitchNavGroup
              key={group.name}
              disabled={group.disabled}
              handleOnClick={handleOnClick}
            />
          ) : (
            <ButtonGroup
              {...group}
              key={group.name}
              group={group.name}
              buttonArr={group.src}
              handleOnClick={handleOnClick}
            />
          )
        )}

        {openFaultsReport && <FaultsReportHoverBox />}
      </Wrapper>
    </StylingWrapper>
  );
};
export default Sidebar;

const StylingWrapper = styled.div`
  ${alignItemsFlexStart}

  height: 100%;
  margin-left: 10rem;
  margin-top: 5rem;
`;

const Wrapper = styled.div`
  width: 64px;
  border-radius: 37px;
  height: 100%;

  background: var(--bg-sidebar);
  border: 1px solid var(--bg-sidebar-border);
  box-shadow: var(--shadow-sidebar);
  padding: 5rem 0;

  display: flex;
  flex-direction: column;
  align-items: center;

  ${(p) =>
    p.positionRelative &&
    css`
      position: relative;
    `}
`;
